import React from 'react';
import {Icon} from 'semantic-ui-react';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {bool, func, string} from 'prop-types';
import BasicModal from 'components/common/BasicModal';

const ConfirmCancelModal = props => (
  <BasicModal
    dimmer={true}
    modalSize='small'
    open={props.isOpen}
    keepModalOnTop={true}
    onClose={props.onClose}
    actions={[
      {
        label: <FormattedMessage id='cancel' />,
        action: props.onClose,
        displayType: 'menu-item'
      },
      {
        label: (
          <React.Fragment>
            <Icon name='check' />
            <FormattedMessage id='confirm' />
          </React.Fragment>
        ),
        action: props.onSubmit,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    header={<FormattedMessage id={props.headerKey} />}
    specialType='caution-modal centered-modal confirm-cancel-modal fadeInUp animResponse'>
    <p>
      <FormattedHTMLMessage id={props.messageKey} />
    </p>
  </BasicModal>
);

ConfirmCancelModal.propTypes = {
  isOpen: bool.isRequired,
  headerKey: string.isRequired,
  messageKey: string.isRequired,

  onClose: func.isRequired,
  onSubmit: func.isRequired
};

export default ConfirmCancelModal;



// WEBPACK FOOTER //
// ./public/components/common/ConfirmCancelModal.jsx